module.exports = {"ADM_INSPECT_ACCOUNTS_SEEING_AS":"Viendo como","ADM_INSPECT_ACCOUNTS_BACK_TO_ADMIN":"Regresar a Admin"}